<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>会员生日活动</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form
        ref="vipBirthdayActivityForm"
        :model="vipBirthdayActivityForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="是否开启活动">
          <el-switch
            size="small"
            v-model="vipBirthdayActivityForm.isEnable"
            active-text="开启"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="活动名称：" prop="activityName">
          <el-input
            size="small"
            v-model="vipBirthdayActivityForm.activityName"
            placeholder="请输入活动名称"
            style="width: 320px"
            :maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <span
            v-if="!currentCoupon.title"
            class="chooseText"
            @click="showDialogCoupon = true"
            >选择优惠券</span
          >
          <div v-else>
            <span>已选择：</span>
            <span>{{ currentCoupon.title }}</span>
            <span class="chooseText" @click="showDialogCoupon = true"> 重新选择</span>
          </div>
        </el-form-item>
        <el-form-item label="会员卡：" prop="memberCardIds">
          <el-select
            size="small"
            v-model="vipBirthdayActivityForm.memberCardIds"
            multiple
            placeholder="请选择"
            @change="shopMemberCardIdsChange"
          >
            <el-option
              v-for="item in memberCardList"
              :key="item.shopMemberCardId"
              :label="item.cardName"
              :value="item.shopMemberCardId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

    <dialog-coupon
      :isShow="showDialogCoupon"
      @hideDialogCoupon="hideDialogCoupon"
      @confirmCoupon="confirmCoupon"
    >
    </dialog-coupon>
  </div>
</template>

<script>
import {
  createMemberBirthdayActivity,
  findBirthdayActivity,
  findCashCouponBatchOrderBean,
  getShopMemberCardList,
} from "../api/index";
import dialogCoupon from "@/components/dialogCoupon.vue";
export default {
  data() {
    return {
      id: "",
      vipBirthdayActivityForm: {
        activityName: "",
        isEnable: false,
        cashCouponBatchId: "",
        memberCardIds: [],
        activityType: 6,
        activityId: "",
      },
      rules: {
        activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期", trigger: "change" }],
        activitySubType: [{ required: true, message: "请选择活动类型", trigger: "blur" }],
      },
      dialogGoodsSel: false,
      activitySubTypeList: [
        { label: "主页关注领券", value: 201 },
        { label: "视频点赞领券", value: 202 },
        { label: "转发朋友圈领券", value: 203 },
      ],
      confirmList: {},
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      attrValueInputVisible: false,
      attrValueInputValue: "",
      showDialogCoupon: false,
      currentCoupon: {},
      memberCardList: [],
    };
  },
  components: {
    dialogCoupon,
  },
  beforeDestroy() {
    localStorage.removeItem("updateActivityId");
  },
  mounted() {
    this.findBirthdayActivity();
    this.getShopMemberCardList();
  },
  methods: {
    shopMemberCardIdsChange(val) {
      console.log(typeof val, val);
    },
    // 隐藏优惠券弹窗
    hideDialogCoupon() {
      this.showDialogCoupon = false;
    },

    confirmCoupon(coupon) {
      this.showDialogCoupon = false;
      this.currentCoupon = coupon;
    },
    handleClose(index) {
      this.vipBirthdayActivityForm.videoHomeVideoIds.splice(index, 1);
    },
    handleAttrValueInputConfirm() {
      let attrValueInputValue = this.attrValueInputValue;
      if (attrValueInputValue) {
        this.vipBirthdayActivityForm.videoHomeVideoIds.push(attrValueInputValue);
      }
      this.attrValueInputVisible = false;
      this.attrValueInputValue = "";
    },
    showAttrValueInput() {
      this.attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput`].focus();
      });
    },
    findBirthdayActivity() {
      findBirthdayActivity().then((res) => {
        if (res.code == 1) {
          res.data.isEnable = res.data.isEnable == 1;
          res.data.memberCardIds = res.data.memberCardIds
            .split(",")
            .map((item) => parseInt(item));
          Object.assign(this.vipBirthdayActivityForm, res.data);
          if (this.vipBirthdayActivityForm.cashCouponBatchId) {
            findCashCouponBatchOrderBean({
              cashCouponBatchOrderId: this.vipBirthdayActivityForm.cashCouponBatchId,
            }).then((coupon) => {
              console.log(coupon);
              if (coupon.code == 1) {
                this.currentCoupon.id = coupon.data.id;
                this.currentCoupon.title = coupon.data.title;
                console.log(this.currentCoupon);
                this.$forceUpdate();
              }
            });
          }
        }
      });
    },
    getShopMemberCardList() {
      getShopMemberCardList({
        pageNo: 1,
        row: 999,
        isEnable: 1,
        isExpire: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.memberCardList = res.data;
        } else if (res.code == -1) {
          this.memberCardList = [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    timeChange(val) {
      if (val && val.length) {
        console.log(val);
        this.vipBirthdayActivityForm.startTime = val[0];
        this.vipBirthdayActivityForm.endTime = val[1];
      } else {
        this.vipBirthdayActivityForm.startTime = "";
        this.vipBirthdayActivityForm.endTime = "";
      }
    },
    priceBlur(e) {
      let value = e.target.value;
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.vipBirthdayActivityForm.score = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.vipBirthdayActivityForm.score = value.toFixed(2);
        }
      }
    },
    submit() {
      this.$refs.vipBirthdayActivityForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        } else {
          let params = JSON.parse(JSON.stringify(this.vipBirthdayActivityForm));
          params.isEnable = params.isEnable ? 1 : 0;
          params.activityId = params.id ? params.id : "";
          params.memberCardIds = params.memberCardIds.join(",");
          params.cashCouponBatchId = this.currentCoupon.id || "";
          createMemberBirthdayActivity(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: `${params.activityId ? "修改成功" : "保存成功"}`,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          });
        }
      });
    },
    deleteGoods() {
      this.confirmList = {};
    },
    confirmSelGoods(confirmList) {
      this.hideSelGoods();
      this.confirmList = confirmList;
    },
    hideSelGoods() {
      this.dialogGoodsSel = false;
    },
  },
};
</script>

<style lang="less" scoped>
.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}
.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}
.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;
  &:last-child {
    cursor: pointer;
  }
}

.chooseText {
  color: rgb(31, 107, 248);
  cursor: pointer;
}
.el-tag {
  margin-right: 10px;
}
</style>
